import './Footer.css';
import { HashLink } from 'react-router-hash-link';
import { FaInstagram } from "react-icons/fa";
import { IoLogoTiktok } from "react-icons/io5";


const Footer = () => {
  return (
	<>
     <footer className="footer">
  		<div className="container_footer">
  	 	<div className="row">
			<div className="footer-col">
				<HashLink to='/#home' smooth={true} duration={4000}>
					<div className='logo_footer' />
				</HashLink>
  	 		</div>
  	 		<div className="footer-col">
  	 			<h4>Time</h4>
  	 			<ul>
  	 				<li>
						<p>
							Saturday <br /><br />
							21:00 – 01:00
						</p>
					</li>
  	 			</ul>
  	 		</div>
  	 		<div className="footer-col">
  	 			<h4>Adress</h4>
  	 			<ul>
  	 				<li><p>
						Norra Stationsgatan 65, <br /><br />
						113 43 Stockholm
					</p></li>
  	 			</ul>
  	 		</div>
  	 		<div className="footer-col">
  	 			<h4>Contact us</h4>
  	 			<ul>
  	 				<li>
						<p>
							<a href='tel:0764130853'>
								076 413 08 53
							</a>
						</p>
						<p>
							<a href="mailto:voccosthlm@gmail.com">
								voccosthlm@gmail.com
							</a>
						</p>
						<p>
							<a href='https://www.instagram.com/voccosthlm/'><FaInstagram className='icon_footer'/></a>
							<a href='https://www.tiktok.com/@vocco.sthlm'><IoLogoTiktok className='icon_footer' /></a>
						</p>       			
					</li>
  	 			</ul>
  	 		</div>
  	 	</div>
  	 </div>
	 <div className='underline'>
		<div className='underline_text'>
			© 2026 Vocco Dinner Club
		</div>
	 </div>
  </footer>
  </>
  )
}

export default Footer